import React, { useState, useEffect } from 'react';
import { useFirebaseContext } from '../context';
import { Core, Background } from '../components';
import { FocusBackground } from '../components/core/styles';
import { DEFAULT_COLOR } from '../constants';
import { ResetContainer } from './styles';

export default function ConfirmResetPassword() {
  const [passwordReset, setPasswordReset] = useState(false);
  const [error, setError] = useState(null);
  const [password, setPassword] = useState('');
  const { firebase } = useFirebaseContext();

  const isInvalid = password === '';

  const confirmPasswordReset = () => {
    firebase
      .auth()
      .confirmPasswordReset(
        new URLSearchParams(window.location.search).get('oobCode'),
        password
      )
      .then(() => {
        setPasswordReset(true);
      })
      .catch((error) => {
        setError(error.message);
        setPassword('');
      });
  };

  useEffect(() => {
    document.title = `Reset Password | Ame`;
  }, []);

  return (
    <>
      <Background />

      <FocusBackground showBox={true}></FocusBackground>

      <ResetContainer>
        <Core.Title>Reset Password.</Core.Title>

        <Core.ListLayout>
          {passwordReset && (
            <Core.Success>Password has been reset!</Core.Success>
          )}
          {error !== null && error != '' && <Core.Error>{error}</Core.Error>}
          <div>
            <Core.Input
              autoFocus
              type='password'
              placeholder='New Password'
              autoComplete='off'
              value={password}
              onChange={({ target }) => setPassword(target.value)}
            />
          </div>
          <Core.Button
            style={{ marginTop: '15px' }}
            color='white'
            bg={DEFAULT_COLOR}
            disabled={isInvalid}
            type='button'
            onClick={() => {
              setError('');
              confirmPasswordReset();
            }}
          >
            Confirm
          </Core.Button>
        </Core.ListLayout>
      </ResetContainer>
    </>
  );
}
